"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var RadixDropdownMenu = _interopRequireWildcard(require("@radix-ui/react-dropdown-menu"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _focus = require("@react-aria/focus");
var _Subheading = _interopRequireDefault(require("../../../components/text/Subheading"));
var _Toggle = _interopRequireDefault(require("../../../components/controls/toggle/Toggle"));
var _Checkbox = _interopRequireDefault(require("../../../components/controls/checkbox/Checkbox"));
var _Button = _interopRequireWildcard(require("../../../components/controls/buttons/Button"));
var _SelectionList = require("../selectionlist/SelectionList.styled");
var _jsxRuntime = require("react/jsx-runtime");
var StyledContent = (0, _styledComponents.default)(RadixDropdownMenu.Content).withConfig({
  displayName: "DropdownList__StyledContent",
  componentId: "sc-1weq5pb-0"
})(["", ";border-color:", ";box-shadow:0 4px 16px 0 rgba(0,0,0,0.12);width:", ";max-height:490px;z-index:100;"], _SelectionList.selectionListCss, _tokens.default.sky.sys.color.border.enabled, function (_ref) {
  var $width = _ref.$width,
    $useTriggerWidth = _ref.$useTriggerWidth;
  return $useTriggerWidth ? (0, _styledComponents.css)(["var(--radix-dropdown-menu-trigger-width)"]) : $width || '299px';
});
var StyledContentGroup = (0, _styledComponents.default)(RadixDropdownMenu.Group).withConfig({
  displayName: "DropdownList__StyledContentGroup",
  componentId: "sc-1weq5pb-1"
})(["width:100%;display:flex;flex-direction:column;padding:", " 0;&:not(:first-child){border-top:1px solid ", ";}&:first-child{padding-top:0;}&:last-child{padding-bottom:0;}"], _tokens.default.sky.sys.spacing['200'], _tokens.default.sky.sys.color.border.decorative);
var StyledContentGroupHeader = _styledComponents.default.div.withConfig({
  displayName: "DropdownList__StyledContentGroupHeader",
  componentId: "sc-1weq5pb-2"
})(["padding:", " ", ";"], _tokens.default.sky.sys.spacing['200'], _tokens.default.sky.sys.spacing['400']);
var StyledItem = (0, _styledComponents.default)(RadixDropdownMenu.Item).withConfig({
  displayName: "DropdownList__StyledItem",
  componentId: "sc-1weq5pb-3"
})(["", ""], _SelectionList.selectableItemCss);
var StyledCheckboxItem = (0, _styledComponents.default)(StyledItem).withConfig({
  displayName: "DropdownList__StyledCheckboxItem",
  componentId: "sc-1weq5pb-4"
})(["button:hover{cursor:pointer;}"]);
var StyledButtonItem = (0, _styledComponents.default)(RadixDropdownMenu.Item).withConfig({
  displayName: "DropdownList__StyledButtonItem",
  componentId: "sc-1weq5pb-5"
})(["display:flex;flex-direction:column;padding:", " ", ";", " ", " button,button:hover{color:", ";}button:hover{border-radius:", ";background:", ";", "}"], _tokens.default.sky.sys.spacing['100'], _tokens.default.sky.sys.spacing['400'], _SelectionList.focusRingCss, _SelectionList.svgCss, _tokens.default.sky.sys.color.text.content.primary, _tokens.default.sky.sys.size.borderradius['3'], _tokens.default.sky.sys.color.background.primary['1'], _SelectionList.svgCss);
var StyledCheckbox = (0, _styledComponents.default)(_Checkbox.default).withConfig({
  displayName: "DropdownList__StyledCheckbox",
  componentId: "sc-1weq5pb-6"
})(["margin-right:10px;"]);
var StyledToggleItem = (0, _styledComponents.default)(StyledItem).withConfig({
  displayName: "DropdownList__StyledToggleItem",
  componentId: "sc-1weq5pb-7"
})(["button:hover{cursor:pointer;}justify-content:space-between;"]);
var DropdownList = function DropdownList(_ref2) {
  var children = _ref2.children,
    _ref2$defaultOpen = _ref2.defaultOpen,
    defaultOpen = _ref2$defaultOpen === void 0 ? false : _ref2$defaultOpen,
    _ref2$open = _ref2.open,
    open = _ref2$open === void 0 ? undefined : _ref2$open,
    _ref2$onOpenChange = _ref2.onOpenChange,
    onOpenChange = _ref2$onOpenChange === void 0 ? undefined : _ref2$onOpenChange;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RadixDropdownMenu.Root, {
    modal: false,
    open: open,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange,
    children: children
  });
};
var Item = function Item(_ref3) {
  var children = _ref3.children,
    disabled = _ref3.disabled,
    onClick = _ref3.onClick,
    dataCy = _ref3['data-cy'];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
    focusRingClass: 'focus-ring',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledItem, {
      disabled: disabled,
      onSelect: onClick,
      "data-cy": dataCy,
      children: children
    })
  });
};
var CheckboxItem = function CheckboxItem(_ref4) {
  var children = _ref4.children,
    _ref4$disabled = _ref4.disabled,
    disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
    onChange = _ref4.onChange,
    dataCy = _ref4['data-cy'],
    checked = _ref4.checked;
  var handleClick = function handleClick() {
    if (!disabled) {
      onChange();
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
    focusRingClass: 'focus-ring',
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledCheckboxItem, {
      onClick: handleClick,
      disabled: disabled,
      "data-cy": dataCy,
      onKeyUp: function onKeyUp(event) {
        return event.stopPropagation();
      },
      onSelect: function onSelect(event) {
        return event.preventDefault();
      },
      onPointerLeave: function onPointerLeave(event) {
        return event.preventDefault();
      },
      onPointerMove: function onPointerMove(event) {
        return event.preventDefault();
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCheckbox, {
        checked: checked,
        onChange: onChange,
        disabled: disabled
      }), children]
    })
  });
};
var ToggleItem = function ToggleItem(_ref5) {
  var children = _ref5.children,
    _ref5$disabled = _ref5.disabled,
    disabled = _ref5$disabled === void 0 ? false : _ref5$disabled,
    onChange = _ref5.onChange,
    _ref5$dataCy = _ref5['data-cy'],
    dataCy = _ref5$dataCy === void 0 ? undefined : _ref5$dataCy,
    checked = _ref5.checked;
  var handleClick = function handleClick() {
    if (!disabled) {
      onChange(!checked);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
    focusRingClass: 'focus-ring',
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledToggleItem, {
      onClick: handleClick,
      disabled: disabled,
      "data-cy": dataCy,
      onKeyUp: function onKeyUp(event) {
        return event.stopPropagation();
      },
      onSelect: function onSelect(event) {
        return event.preventDefault();
      },
      onPointerLeave: function onPointerLeave(event) {
        return event.preventDefault();
      },
      onPointerMove: function onPointerMove(event) {
        return event.preventDefault();
      },
      children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Toggle.default, {
        checked: checked,
        onChange: onChange,
        disabled: disabled
      })]
    })
  });
};
var ButtonItem = function ButtonItem(_ref6) {
  var children = _ref6.children,
    onClick = _ref6.onClick,
    dataCy = _ref6['data-cy'];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
    focusRingClass: 'focus-ring',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButtonItem, {
      onSelect: function onSelect(e) {
        onClick();
        e.preventDefault();
      },
      onPointerLeave: function onPointerLeave(event) {
        return event.preventDefault();
      },
      onPointerMove: function onPointerMove(event) {
        return event.preventDefault();
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        emphasis: _Button.EMPHASIS.LOW,
        "data-cy": dataCy,
        children: children
      })
    })
  });
};
var StyledDropdownItem = (0, _styledComponents.default)(RadixDropdownMenu.Item).withConfig({
  displayName: "DropdownList__StyledDropdownItem",
  componentId: "sc-1weq5pb-8"
})(["padding:", " ", ";", ""], _tokens.default.sky.sys.spacing['100'], _tokens.default.sky.sys.spacing['400'], _SelectionList.focusRingCss);
var DropdownItem = function DropdownItem(_ref7) {
  var children = _ref7.children;
  var _ref11 = (0, _react.useState)(false),
    _ref12 = _slicedToArray(_ref11, 2),
    open = _ref12[0],
    setOpen = _ref12[1];
  var ref = (0, _react.useRef)(null);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
    focusRingClass: 'focus-ring',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDropdownItem, {
      ref: ref,
      onSelect: function onSelect(e) {
        if (!open) {
          setOpen(true);
        }
        e.preventDefault();
      },
      onPointerLeave: function onPointerLeave(event) {
        return event.preventDefault();
      },
      onPointerMove: function onPointerMove(event) {
        return event.preventDefault();
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DropdownList, {
        open: open,
        onOpenChange: function onOpenChange(open) {
          if (!open) {
            var _ref$current;
            if (ref !== null && ref !== void 0 && (_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.focus) {
              ref.current.focus();
            }
          }
          setOpen(open);
        },
        children: children
      })
    })
  });
};
var Trigger = function Trigger(_ref8) {
  var children = _ref8.children,
    other = _objectWithoutProperties(_ref8, ["children"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RadixDropdownMenu.Trigger, _objectSpread({
    asChild: true
  }, other, {
    children: children
  }));
};
var Content = function Content(_ref9) {
  var _ref9$offset = _ref9.offset,
    offset = _ref9$offset === void 0 ? 0 : _ref9$offset,
    _ref9$align = _ref9.align,
    align = _ref9$align === void 0 ? 'end' : _ref9$align,
    _ref9$side = _ref9.side,
    side = _ref9$side === void 0 ? 'bottom' : _ref9$side,
    width = _ref9.width,
    useTriggerWidth = _ref9.useTriggerWidth,
    children = _ref9.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledContent, {
    sideOffset: offset,
    align: align,
    side: side,
    $width: width,
    $useTriggerWidth: useTriggerWidth,
    tabIndex: 0,
    children: children
  });
};
var ContentGroup = function ContentGroup(_ref10) {
  var title = _ref10.title,
    children = _ref10.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledContentGroup, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledContentGroupHeader, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Subheading.default, {
        children: title
      })
    }), children]
  });
};
DropdownList.Trigger = Trigger;
DropdownList.Content = Content;
DropdownList.Item = Item;
DropdownList.ButtonItem = ButtonItem;
DropdownList.DropdownItem = DropdownItem;
DropdownList.CheckboxItem = CheckboxItem;
DropdownList.ToggleItem = ToggleItem;
DropdownList.ContentGroup = ContentGroup;
var _default = exports.default = DropdownList;